import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import ReportForm from '../components/ReportForm'

export default function Report() {
  return (
    <div className="home-page">
    <Navbar />
    <ReportForm />
  
    <Footer />
  </div>
  )
}
